import React, { useState } from 'react';
import { faqs } from '../mock';
import { Plus, Minus } from 'lucide-react';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="jh-section bg-[#f5f5f7]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-start">
        <div className="lg:sticky lg:top-32">
          <span className="jh-eyebrow">Frequently Asked Questions</span>
          <h2 className="jh-h2 text-[#0e1421] mt-4 mb-6">
            Everything You Need to Know Before You Partner With Us
          </h2>
          <p className="text-gray-600 leading-relaxed mb-8">
            Whether you’re an employer, job seeker or partner — here are the
            questions we hear most often about our recruitment services.
          </p>

          <div className="relative rounded-xl overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3ODQ4MDA5NDJ8MA&ixlib=rb-4.1.0&q=85"
              alt="Recruitment partnership"
              className="w-full h-[280px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0e1421]/80 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <div className="text-white font-display font-extrabold text-[22px] leading-tight">
                Trusted by Employers Worldwide
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {faqs.map((f, i) => (
            <div
              key={i}
              className={`bg-white rounded-lg border transition-all ${
                open === i ? 'border-[#E11D2E] shadow-lg' : 'border-black/10'
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-6 text-left"
              >
                <span className="font-display font-bold text-[17px] text-[#0e1421] leading-tight">
                  {f.q}
                </span>
                <span
                  className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                    open === i
                      ? 'bg-[#E11D2E] text-white'
                      : 'bg-[#f5f5f7] text-[#0e1421]'
                  }`}
                >
                  {open === i ? <Minus size={16} /> : <Plus size={16} />}
                </span>
              </button>
              <div
                className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
                  open === i ? 'max-h-[400px]' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 text-gray-600 leading-relaxed text-[15px]">
                  {f.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
